export default __webpack_public_path__ + "static/media/staff4.02b06ca2.jpg";